import React from "react";
import * as C from "./styles";
import { FiLogOut } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { HiUserCircle } from "react-icons/hi2";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

type Props = {
  setSidebarOpened: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarOpened: boolean;
};

export default function Header({ setSidebarOpened, sidebarOpened }: Props) {
  const navigate = useNavigate();
  const [isMenuOpened, setIsMenuOpened] = React.useState<boolean>(false);
  const ref = React.useRef(null) as React.RefObject<HTMLDivElement>;
  const [currentProfile, setCurrentProfile] = React.useState<string>(
    localStorage.getItem("perfilEncarregado") ?? ""
  );

  let currentPage =
    useLocation()
      .pathname.split("/")
      .slice(-1)[0]
      .replaceAll("-", " ")
      .charAt(0)
      .toUpperCase() +
    useLocation()
      .pathname.split("/")
      .slice(-1)[0]
      .replaceAll("-", " ")
      .substring(1);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate(0);
  };

  React.useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpened(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      <C.MainContainer>
        <C.Hamburguer
          onClick={() => setSidebarOpened(!sidebarOpened)}
        ></C.Hamburguer>
        <C.ShowLocation>
          {!currentPage.includes("%") ? currentPage : ""}
        </C.ShowLocation>
        <FiLogOut onClick={handleLogout} />
      </C.MainContainer>
    </>
  );
}
